import React from 'react';
import { makeStyles } from '@material-ui/core/styles';
import { loginRedirect } from '../redux/auth';
import { parseQueryString } from '../Utils/GlobalUtils';
import { useLocation } from 'react-router-dom';
import Grid from '@material-ui/core/Grid';
import Button from '@material-ui/core/Button';
import Typography from '@material-ui/core/Typography';
import CorgisLogo from '../icons/CorgisLogo';

function extractAndParseQueryString(location) {
	return {
		...parseQueryString(location.search),
		...parseQueryString(window.location.search),
	};
}

const useStyles = makeStyles((theme) => ({
	loginRoot: { height: '100vh' },
	top: {
		padding: '0 0 2rem 0',
		backgroundColor: theme.palette.brand.main,
	},
	bottom: {
		padding: '2rem 0 0 0',
		backgroundColor: '#E8EDF2',
	},
	button: {
		width: '8rem',
		height: '2.25rem',
		borderRadius: '0',
		borderWidth: '0.125rem',
		color: 'white',
	},
}));

const Login = () => {
	const classes = useStyles();
	const location = useLocation();
	const { code, from } = extractAndParseQueryString(location);

	function login(e) {
		e.preventDefault();
		loginRedirect(false, from);
	}
	console.log('login component', location);

	if (code) {
		return (
			<Grid className={classes.loginRoot} container justify="center" alignItems="center">
				<Typography variant="h4">One moment, logging you in&hellip;</Typography>
			</Grid>
		);
	}

	return (
		<Grid className={classes.loginRoot} container>
			<Grid container xs={12} className={classes.top} justify="center" alignItems="flex-end">
				<CorgisLogo />
			</Grid>
			<Grid container xs={12} className={classes.bottom} justify="center" alignItems="flex-start">
				<Button
					className={classes.button}
					justifyContent="center"
					variant="contained"
					size="large"
					color="primary"
					onClick={login}
				>
					Log in
				</Button>
			</Grid>
		</Grid>
	);
};

export default Login;
